"use client";

import { AvatarOsoby } from "./avatar-osoby";
import { AvatarData } from "@/lib/avatar-utils";

interface UserAvatarProps {
  userId?: string;
  meno?: string;
  email?: string;
  avatarUrl?: string | null;
  avatarVerzia?: number;
  className?: string;
  fallbackClassName?: string;
}

export function UserAvatar({
  userId,
  meno,
  email,
  avatarUrl,
  avatarVerzia,
  className,
  fallbackClassName,
}: UserAvatarProps) {
  if (!userId) {
    // Fallback pre anonymného používateľa
    return (
      <AvatarOsoby
        typ="profil"
        id="anonymous"
        meno={meno || email || "Anonymous"}
        className={className}
        fallbackClassName={fallbackClassName}
      />
    );
  }

  const avatarData: AvatarData = {
    avatar_url: avatarUrl || null,
    avatar_verzia: avatarVerzia || 0,
  };

  return (
    <AvatarOsoby
      typ="profil"
      id={userId}
      meno={meno || email || "User"}
      avatarData={avatarData}
      className={className}
      fallbackClassName={fallbackClassName}
    />
  );
}
